import { List, Record } from 'immutable';

const ModalFactory = new Record({
  isOpenDocumentHotkeysModal: false,
  isOpenWorkspaceHotkeysModal: false,
});

export const validStampMode = ['visible', 'edit', 'move', 'hidden'];

export const UiAFStampFactory = new Record({
  ll: List([0, 0]),
  ur: List([0, 0]),
  rotation: 0,
});

const ApprovalFlowFactory = new Record({
  isOpen: false,
  stampMode: 'hidden',
  stamp: null,
});

const WorkspaceFactory = new Record({
  isActiveContextMenu: false,
});

const DrawerFactory = new Record({
  isOpen: false,
});

const SelectFactory = new Record({
  isOpen: false,
});

export const DeferredToastFactory = new Record({
  type: 'success',
  message: '',
});

const ToastFactory = new Record({
  deferred: List(),
});

export const UiStateFactory = new Record({
  modal: ModalFactory(),
  approvalFlow: ApprovalFlowFactory(),
  workspace: WorkspaceFactory(),
  drawer: DrawerFactory(),
  select: SelectFactory(),
  toast: ToastFactory(),
});
